<template>
  <a
    class="info-section-tutorial-tile"
    data-testid="tutorial-tile"
    :href="props.link"
    target="_blank"
    rel="noopener noreferrer"
  >
    <div class="info-section-tutorial-tile__icon" data-testid="tutorial-icon">
      <img :src="props.icon" data-testid="tutorial-icon-image" />
      <v-divider class="info-section-tutorial-tile__divider" vertical opacity="1" />
    </div>
    <h3 class="info-section-tutorial-tile__title pre-line" data-testid="tutorial-title">
      {{ props.title }}
    </h3>
    <p v-orphans class="info-section-tutorial-tile__text" data-testid="tutorial-text">
      {{ props.text }}
    </p>
    <span class="info-section-tutorial-tile__submit" data-testid="tutorial-link" aria-hidden="true">
      <v-icon color="white">
        {{ props.submitIcon }}
      </v-icon>
    </span>
  </a>
</template>

<script setup lang="ts">
import Tutorial from '@/assets/images/infoSection/tutorial.png'

type Props = {
  title: string
  text: string
  icon?: string
  submitIcon?: string
  link: string
}

const props = withDefaults(defineProps<Props>(), {
  icon: Tutorial,
  submitIcon: '$chevronRight'
})
</script>

<style lang="scss">
@use '@/assets/css/variables.scss' as variables;
@use 'sass:map';

.info-section-tutorial-tile {
  background-color: #fff;
  color: #000;
  display: grid;
  gap: 16px;
  grid-template-columns: auto 1fr auto;
  grid-template-areas:
    'icon title submit'
    'icon text submit';
  border: 2px solid #d9d9d9;

  // The whole tile is the link (the arrow is only decoration)
  text-decoration: none;
  cursor: pointer;
  transition:
    border-color 0.15s,
    box-shadow 0.15s;

  &:hover {
    color: #000;
    border-color: #bdbdbd;
    box-shadow: 0 10px 26px -16px rgb(42 23 21 / 35%);
  }

  &:focus-visible {
    outline: 3px solid var(--sz-focus-blue);
    outline-offset: 3px;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }

  &__icon {
    grid-area: icon;
    align-self: center;
    align-items: center;
    margin-left: 8px;
    display: none;

    @media (min-width: map.get(variables.$grid-breakpoints, 'md')) {
      display: block;
    }

    img {
      max-width: 75px;
      height: auto;
    }
  }

  &__title {
    grid-area: title;
    font-weight: 500;
    margin-top: 16px;
  }

  &__text {
    grid-area: text;
    margin-bottom: 16px;
  }

  &__submit {
    grid-area: submit;
    align-self: stretch;
    background-color: #ed1c24;
    display: flex;
    align-items: center;
    padding: 0 8px;
  }

  &__divider {
    height: 90px;
    padding: 0 8px;
    color: #d9d9d9;
  }
}
</style>
